import arLogo from "../new-icon/logo-ar.svg";
import enLogo from "../new-icon/logo-en.svg";
import arLogoBlue from "../new-icon/logo-ar-blue.svg";
import enLogoBlue from "../new-icon/logo-en-blue.svg";
import markLogo from "../images/bdaiatMark.svg";
import { useTranslation } from "react-i18next";

function BrandLogo({ className = "logo", variant = "white", alt, id }) {
  const { i18n } = useTranslation();
  const isAr = (i18n.language || "ar").startsWith("ar");

  let src;
  if (variant === "mark") {
    src = markLogo;
  } else if (variant === "blue") {
    src = isAr ? arLogoBlue : enLogoBlue;
  } else {
    src = isAr ? arLogo : enLogo;
  }

  return (
    <img
      id={id}
      className={className}
      src={src}
      alt={alt || (isAr ? "بدايات" : "Bdaiat")}
    />
  );
}

export default BrandLogo;
